import { render } from "./SearchAdRail.vue?vue&type=template&id=b8ec1cda&scoped=true"
import script from "./SearchAdRail.vue?vue&type=script&lang=js"
export * from "./SearchAdRail.vue?vue&type=script&lang=js"

import "./SearchAdRail.vue?vue&type=style&index=0&id=b8ec1cda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8ec1cda"]])

export default __exports__